// MAGIC_DESPROCKET_START
// !!!!!!!!!This file was copied from a gem!!!!!!!!!
// It was originally at: ../rbenv/versions/2.6.3/lib/ruby/gems/2.6.0/gems/rails-assets-scroll-scope-0.1.0/app/assets/javascripts/scroll-scope.js

// MAGIC_DESPROCKET_END
//= require scroll-scope/scroll-scope.js
// MAGIC_DESPROCKET_START
require('javascripts/former-gems/rails-assets-scroll-scope-0.1.0/app/assets/javascripts/scroll-scope/scroll-scope.js')
// MAGIC_DESPROCKET_END
